import { enableProdMode, NgModuleRef } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { hmr } from '@ngxs/hmr-plugin';
import * as moment from 'moment-timezone';

import { AUTH_METHOD, AUTH_TOKEN, NoopNgZone } from '@recruitee/common';
import { patchMoment } from '@recruitee/i18n';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { authService, authStrategy } from './main-deps';

import './vendor';

const _jQuery = require('jquery');
// @ts-ignore
window['jQuery'] = _jQuery;
// @ts-ignore
window['moment'] = moment;
require('moment/locale/de');
require('moment/locale/nl');
require('moment/locale/fr');
patchMoment(moment);
moment.locale('en');

if (environment.production) {
  enableProdMode();
}

const getAuthToken = async (): Promise<string | void> => {
  try {
    return await authService.getAccessToken();
  } catch (err) {
    console.warn(`~~~~~~ getAccessToken ERROR ~~~~~~`);
    console.error(err);
  }
};

const bootstrap = async () => {
  const authToken = await getAuthToken();

  if (!authToken) {
    authStrategy.onAuthorizationFailed();
  }

  const ngModule: NgModuleRef<any> = await platformBrowserDynamic([
    { provide: AUTH_TOKEN, useValue: authToken },
    { provide: AUTH_METHOD, useValue: 'Bearer' },
  ]).bootstrapModule(AppModule, {
    ngZone: new NoopNgZone(),
  });

  return ngModule;
};

const bootstrapApp = async () => {
  if (environment.hmr) {
    // @ts-ignore
    if (module['hot']) {
      hmr(module, bootstrap);
    } else {
      console.error('HMR is not enabled for webpack-dev-server!');
      // eslint-disable-next-line no-console
      console.log('Are you using the --hmr flag for ng serve?');
    }
  } else {
    await bootstrap();
  }
};

bootstrapApp();
